import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CustomAlert from '../CustomAlert';
import { hideAlert } from '../../store/actions/alertAction';
import config from '../../config/Constant';

const GlobalAlert = () => {
  const alertState = useSelector((state) => state.alert);
  const dispatch = useDispatch();

  useEffect(() => {
    if (alertState.show) {
      const timer = setTimeout(() => {
        dispatch(hideAlert());
      }, config.notify_time);
      return () => clearTimeout(timer);
    }
  }, [alertState.show, dispatch]);

  return (
    <CustomAlert
      message={alertState.message}
      show={alertState.show}
      variant={alertState.variant}
      closeAlert={() => dispatch(hideAlert())}
    />
  );
};

export default GlobalAlert;
